import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import './SearchBar.scss';  // Import the stylesheet

export interface ISearchBarProps {
    placeholder?: string;
    value: string;
    onChange(newValue: string): void;
}

export function SearchBar(props: ISearchBarProps) {
    // Local handler to convert event to string
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event.target.value);
    };

    return (
        <div className="search-bar">
            <div className="search-bar-icon">
                <FontAwesomeIcon icon={faSearch} />
            </div>
            <input
                className="search-bar-input"
                value={props.value}
                onChange={handleInputChange} // Use the local handler
                placeholder={props.placeholder}
            />
            {
                props.value && (
                    <div
                        onClick={() => props.onChange("")}
                        aria-expanded={props.value ? "true" : "false"}
                        className="search-bar-icon search-bar-icon-button"
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                )
            }
        </div>
    );
}

export default SearchBar;
